export const formatSupportedFileTypes = (
	supportedFileTypes: Record<string, string>,
) => {
	const unique = [...new Set(Object.values(supportedFileTypes))]
	const last = unique.pop() || ''
	if (unique.length < 1) {
		return last
	}
	return unique.join(', ').concat(' & ', last)
}
